import React from 'react';
import './css/CreatorCardWithRound.css';
import { DEFAULT_USER_AVATAR, ROLE } from '../../shared/constants/common';
import FollowPPVCreatorButton from '../buttons/FollowPPVCreatorButton';
import ViewProfileButton from '../buttons/ViewProfileButton';
import { getSubscriptionPriceWithExtraCharge } from '../../shared/utils/paymentUtil';
import { truncateUsernameDisplay } from '../../shared/utils/usernameFormat';

const CreatorCardWithRound = ({ 
  creator, 
  vatPercentage = 0,
  onFollowSuccess, 
  onUnfollowSuccess 
}) => {
  return (
    <div className="creator-card">
      {/* Profile Picture */}
      <div className="profile-picture-container">
        <img
          src={creator.profile_picture && creator.profile_picture !== 'default/default-user.jpeg' 
            ? creator.profile_picture
            : DEFAULT_USER_AVATAR
          }
          alt={creator.username}
          className="profile-picture"
          onError={(e) => {
            e.target.src = DEFAULT_USER_AVATAR;
          }}
        />
      </div>

      <div className={`username ${creator.rol === ROLE.CREATOR_SUB ? 'with-price' : ''}`}>
        {truncateUsernameDisplay(creator.username)}
      </div>

      {/* Price for subscription-based creators */}
      {creator.rol === ROLE.CREATOR_SUB && creator.price && (
        <div className="price">
          {`${getSubscriptionPriceWithExtraCharge(creator.price, creator?.active_promotion, vatPercentage)}`}
        </div>
      )}

      {/* Action Buttons */}
      <div className="action-buttons">
        {creator.rol === ROLE.CREATOR_CONTENT && (
          <FollowPPVCreatorButton
            creator={creator}
            onFollowSuccess={onFollowSuccess}
            onUnfollowSuccess={onUnfollowSuccess}
          >
            <button className={`follow-button ${creator.isFollowing ? 'following' : ''}`}>
              {creator.isFollowing ? 'Following' : 'Follow'}
            </button>
          </FollowPPVCreatorButton>
        )}
        
        <ViewProfileButton creator={creator}>
          <button className={`view-button ${creator.rol !== ROLE.CREATOR_CONTENT ? 'without-follow' : ''}`}>
            View
          </button>
        </ViewProfileButton>
      </div>
    </div>
  );
};

export default CreatorCardWithRound;